<script>
  import {Event} from '../../plugins/bus';
  import {GarageLocationStore} from '../../stores/GarageLocationStore';
  import moment from 'moment';
  import {DateFormat} from '../../plugins/date-filter';
  import UserClient from '@/components/Users/UsersClient.vue';

  export default {
    mixins: [UserClient],
    data() {
      return {
        garageLocationStore: GarageLocationStore.data,
        fetching: {}
      };
    },
    computed: {
      garages() {
        return this.garageLocationStore.garages;
      },
      vehicleGarageLocations() {
        return this.garageLocationStore.vehicleGarages;
      },
      userGarage() {
        return this.garageLocationStore.userGarage;
      },
      userGarages() {
        return this.garageLocationStore.userGarages;
      },
      userGarageLocations() {
        if (!this.garageLocationStore || !this.garageLocationStore.garages || !this.garageLocationStore.userGarages) {
          return;
        }
        const store = this.garageLocationStore;
        return store.garages.filter(x => !!store.userGarages.filter(g => g == x.id).length);
      },
      garageUnits() {
        return this.garageLocationStore.garageUnits;
      },
      garageErrors() {
        return this.garageLocationStore.garageErrors;
      },
      garageName() {
        return this.garageLocationStore.garageName;
      }
    },
    methods: {
      async loadUserGarages() {
        if (!GarageLocationStore.data.userGarages || !GarageLocationStore.data.userGarages.length) {
          const user = await this.getCurrentUser();
          GarageLocationStore.methods.updateUserGarages(user.garages);
        }
      },
      async getGarageSelections() {
        if (GarageLocationStore.data.hasAllGarages) {
          return GarageLocationStore.data.garages;
        }

        try {
          this.$wait.start('loading garage locations');
          const response = await this.$api.get(`garage-selection`);
          GarageLocationStore.methods.updateGarageSelections(response.data);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting garage locations');
          return null;
        } finally {
          this.$wait.end('loading garage locations');
        }
      },
      async getGarageLocations(forceRefresh = false) {
        if (!forceRefresh && GarageLocationStore.data.hasGarageDetails) {
          return GarageLocationStore.data.garageDetails;
        }

        try {
          this.$wait.start('loading garage locations');
          const response = await this.$api.get(`garage-locations`);
          GarageLocationStore.methods.updateGarageDetails(response.data);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting garage locations');
          return null;
        } finally {
          this.$wait.end('loading garage locations');
        }
      },
      async getVehicleGarageLocations() {
        try {
          this.$wait.start('loading garage locations');
          const response = await this.$api.get(`vehicle-garage-locations`);
          GarageLocationStore.methods.updateVehicleGarages(response.data);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting garage locations');
          return null;
        } finally {
          this.$wait.end('loading garage locations');
        }
      },
      async getContainerGarageLocations() {
        try {
          this.$wait.start('loading container garage locations');
          const response = await this.$api.get(`container-garage-locations`);
          return response.data;
        } catch (error) {
          this.$toast.error('There was an error getting container garage locations');
          return null;
        } finally {
          this.$wait.end('loading container garage locations');
        }
      },
      async getUnitSummaryForGaragePeriod(garageId, from, to) {
        var key = `${garageId}${from}${to}`;
        if (this.fetching[key]) {
          return;
        }
        this.fetching[key] = true;
        var today = moment(new Date())
          .startOf('day')
          .format(DateFormat.Canonical);
        try {
          this.$wait.start('loading garage unit summary');
          GarageLocationStore.methods.updateGarageSummary(null, null, null);
          const response = await this.$api.get(`garage-locations/${garageId}/unit-summary?from=${from}&to=${to}`);
          this.$bus.$emit(Event.GarageUnitSummaryUpdated, response.data);
          return response.data;
        } catch (error) {
          if (error.response.status === 404) {
            return {
              garageName: '',
              vehicleCount: 0,
              containerCount: 0,
              unitsWithoutConfigCount: 0,
            };
          } else {
            this.$toast.error('There was an error getting unit summary');
          }
        } finally {
          this.$wait.end('loading garage unit summary');
          this.fetching[key] = false;
        }
        return null;
      },
      handleUnitSummaryUpdated(data) {
        GarageLocationStore.methods.updateGarageSummary(data.garageName, data.unitCount, data.unitsWithoutConfigCount);
      },
      hasSelectedGarage() {
        return GarageLocationStore.methods.hasSelectedGarage();
      },
      async saveGarageLocation(value) {
        try {
          this.$wait.start('saving garage location');
          const response = await this.$api.put(`garage-locations/${value.id}`, value);
          return response;
        } catch (error) {
          this.$toast.error('There was an error saving garage location');
          return null;
        } finally {
          this.$wait.end('saving garage location');
        }
      }
    },
    mounted() {
      this.$bus.$on(Event.GarageUnitSummaryUpdated, this.handleUnitSummaryUpdated);
    },
    destroyed() {
      this.$bus.$off(Event.GarageUnitSummaryUpdated, this.handleUnitSummaryUpdated);
    }
  };
</script>
